import { useApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { TenantProfile } from '@hetivo/hetivo-lib-types';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useMemo } from 'react';

import { createTenantProfileApi } from './tenant-profile.api';
import { tenantProfileQueryOptions } from './tenant-profile.query-options';

/**
 * Memoizes the `GET /tenants/me` api (from `useApiClient`) and the resulting query options, so every
 * reader — `useTenantProfile` and `useTenantModules` — shares one stable options object without each
 * re-creating the api on every render (SWOOP-300). The single source of truth for the key/fetcher/staleTime
 * stays {@link tenantProfileQueryOptions}; this hook only supplies the client-bound api.
 */
export function useTenantProfileQueryOptions(): Pick<
  UseQueryOptions<TenantProfile>,
  'queryFn' | 'queryKey' | 'staleTime'
> {
  const client = useApiClient('admin-auth');
  return useMemo(() => tenantProfileQueryOptions(createTenantProfileApi(client)), [client]);
}
